export const TextFormate = (data, length) => {
  return parseFloat(data).toFixed(length) ?? "-";
};
